import { Response } from './utils/providerResponse';
import { post, get } from './api';
import { normalizeModelValidationErrors } from './helpers';

function toQueryString(query) {
    return Object.keys(query).reduce((queryString, param) => {
        if (queryString) {
            queryString += '&';
        }
        return queryString += [param, query[param]].join('=');
    }, '');
}

export function enter(values, fromPartner) {
    var apiKey = fromPartner ? "enterFromPartner" : "enter";
    return post(`account/${apiKey}?` + toQueryString(values), {});
}

export function login(values) {
    return post(
        'account/login',
        values
    )
        .catch((res) => {
            switch (res.status) {
                case 400:
                    const errors = normalizeModelValidationErrors(res.data.ModelState);

                    return Promise.reject({
                        ...res,
                        data: errors,
                        message: "Логин или пароль введены неверно",
                    });
                default:
                    return Promise.reject(res);
            }
        });
}

export function register(values) {
    return post('account/requestRegistration', values)
        .catch((res) => {
            switch (res.status) {
                case 400:
                    const errors = normalizeModelValidationErrors(res.data.ModelState);

                    const isEmptyErrors = !Object.keys(errors).length;
                    const message = res.data.message
                        ? res.data.message
                        : res.message;

                    return Promise.reject({
                        status: res.status,
                        data: errors,
                        message: isEmptyErrors && message,
                    });
                default:
                    return Promise.reject(res);
            }
        });
}

export function logout() {
    return post('account/logout', {});
}

export function recovery(value) {
    return post('account/RecoveryPassword', {value})
        .catch((res) => {
            switch (res.status) {
                case 400:
                    return Promise.reject({
                        ...res,
                        message: res.data && res.data.message
                            ? res.data.message
                            : res.message,
                    });
                default:
                    return Promise.reject(res);
            }
        });
}

export function demoAccess(values) {
    if (process.env.NODE_ENV === 'development') {
        return new Promise((res, rej) => {
            setTimeout(res, 2000);
        })
    }

    return post('account/demo', values).catch((res) => {
        switch (res.status) {
            case 400:
                const errors = normalizeModelValidationErrors(res.data.ModelState);

                return Promise.reject({
                    ...res,
                    data: errors,
                    message: 'DuplicateUserName' === res.message
                        ? 'Такой email уже зарегистрирован'
                        : undefined,
                });
            default:
                return Promise.reject(res);
        }
    });
}

export function changePassword(values) {
    return post('account/changePassword', values).catch((res) => {
        return Promise.reject(res);
    });
}

export function verificationEmail(email) {
    const messages = {
        '-1': 'Ошибка',
        '0': '',
        '1': 'Такой email уже зарегистрирован',
        '2': 'Такой email уже зарегистрирован',
    };

    // if (process.env.NODE_ENV === 'development') {
    //     return new Promise((res, rej) => {
    //         console.log('verificationEmail called');
    //         setTimeout(() => {
    //             rej({
    //                 status: 400,
    //                 message: 'Такой email уже зарегистрирован',
    //                 data: '',
    //             });
    //         }, 500);
    //     })
    // }

    return get('account/verificationEmail?email=' + email)
        .then((res) => {
            if (String(res.data) === '0') {
                return res;
            }

            throw new Response(
                res.data,
                400,
                messages[String(res.data)] || 'Вы не можете использовать этот email'
            );
        })
        .catch((res) => {
            throw res;
        });
}


// WEBPACK FOOTER //
// ./src/services/api/account.js